<template>
  <div :class="$t('security.security-class-name')">
    <page-navigate></page-navigate>

    <div class="security1">
      <div class="container">
        <p class="public-title title-48_bold md-title-24_bold">全球监管资质</p>
        <div class="row">
          <div class="col-md-4 ">
            <template v-if="$t('common.lang') != 'jp'">
              <img src="../assets/image/index/index-new-01.svg" alt="">
              <p class="p2">{{ $t('WhyEBC.screen3.desc-l1') }}</p>
              <p class="p2">{{ $t('WhyEBC.screen3.desc-l2') }}</p>
              <p class="p2">{{ $t('WhyEBC.screen3.desc-l3') }}</p>
              <a href="https://register.fca.org.uk/s/firm?id=0014G00002Vq7yNQAR" rel="nofollow"
                target="_blank">{{ $t('security.security-page1.text2') }}</a>
            </template>
          </div>
          <div class="col-md-4">
            <img src="../assets/image/index/index-new-03.svg" alt="">
            <p class="p2">{{ $t('WhyEBC.screen3.desc-rr1') }}</p>
            <p class="p2">{{ $t('WhyEBC.screen3.desc-rr2') }}</p>
            <p class="p2">{{ $t('WhyEBC.screen3.desc-rr3') }}</p>
            <a href="https://www.cima.ky/search-entities-cima/get_search_data" rel="nofollow"
              target="_blank">{{ $t('security.security-page1.text2') }}</a>
          </div>
          <div class="col-md-4 ">
            <template v-if="$t('common.lang') != 'jp'">
              <img src="../assets/image/index/index-new-02.svg" alt="">
              <p class="p2">{{ $t('WhyEBC.screen3.desc-r1') }}</p>
              <p class="p2">{{ $t('WhyEBC.screen3.desc-r2') }}</p>
              <p class="p2">{{ $t('WhyEBC.screen3.desc-r3') }}</p>
              <a href="https://service.asic.gov.au/search/"
                rel="nofollow" target="_blank">{{ $t('security.security-page1.text2') }}</a>
            </template>
          </div>
          <div class="col-md-3">
              <img
                src="../assets/image/index/index-new-04.svg?t=1690948731"
                alt=""
              />
              <p class="p2">EBC Financial Group SA (Pty) Ltd</p>
              <p class="p2">
                由南非金融部门行为监管局（FSCA）<br class="pc" />授权和监管
              </p>
              <p class="p2">监管号：51541</p>
              <a
                href="https://www.fsca.co.za/Entity-Persons-Search/?iframe_target=financial-services-providers"
                rel="nofollow"
                target="_blank"
                >查看牌照</a
              >
            </div>
        </div>
      </div>
    </div>


    <div class="security2">
      <div class="">
        <p class="public-title title-48_bold md-title-24_bold">{{ $t('security.security-page2.text1') }}</p>
        <div class="row">
          <div class="col-md-12 list-box">
            <div class="securityImg">
             <img src="../assets/image/security2-logo1.png" alt="">
            </div>
            <div class="con-box">
              <p class="p1">FSCS 补偿保障</p>
              <p class="p2">
                EBC Financial Group (UK) Limited 由英国金融行为监管局（FCA）授权并监管。该英国实体仅向专业客户提供涵盖多类产品的优质交易执行服务。<span class="br"></span>
                金融服务补偿计划（FSCS）由英国政府设立，是英国授权金融服务公司在无力偿付时作为最后救济机制的补偿基金，为其客户提供金融保障。<span class="br"></span>
                该计划可为符合资格的索赔申请人提供最高 85,000 英镑的保障。
              </p>
              <router-link
                :to="'/LearningCenterInfo?id=LEARN-196-367'">{{ $t('security.security-page2.text10') }}</router-link>
            </div>
          </div>
          <div class="col-md-12 list-box">
            <div class="securityImg">
             <img src="../assets/image/security2-logo2.png" alt="">
            </div>
            <div class="con-box">
              <p class="p1">巴克莱银行最高级别 Corporate Banking Account</p>
              <p class="p2">EBC Financial Group（UK）Limited 和 EBC Financial Group（Cayman）Limited 拥有巴克莱银行最高级别企业账户，该账户要求企业营业额和存款达到650万英镑以上，且须要通过巴克莱一系列严格的财务审计和背景调查。<span class="br"></span>EBC Financial Group（UK）Limited 严格执行CASS规定，EBC Financial Group（Cayman）Limited 严格执行 CIMA 的 SIBA 法案，通过特定信托函独立托管投资者资金，保障资金安全与独立。</p>
              <router-link
                :to="'/LearningCenterInfo?id=LEARN-770-2FF'">{{ $t('security.security-page2.text10') }}</router-link>
            </div>
          </div>
          <div class="col-md-12 list-box">
             <div class="securityImg">
             <img src="../assets/image/security2-logo31.png" alt="">
             <img src="../assets/image/security2-logo32.png" alt="">
            </div>
            <div class="con-box">
              <p class="p1">{{ $t('security.security-page2.text6') }}</p>
              <p class="p2">
              "The Financial Commission 作为全球首个独立的外部争议解决（EDR）机构，通过其严格、透明和公开的审理机制，保证交易争议的快速公正解决。迄今争议处理总额已超过6700万美元，并处理超一万起争端。EBC集团旗下子公司加入其赔付基金，为每位合资格客户提供最高20000欧元的赔付保障*。 <span class="br"></span>
*受保险条款和细则约束"</p>
              <router-link
                :to="'/LearningCenterInfo?id=LEARN-2C9'">{{ $t('security.security-page2.text10') }}</router-link>
            </div>
          </div>
          <div class="col-md-12 list-box">
            <div class="securityImg">
             <img src="../assets/image/security2-logo41.png" alt="">
             <img src="../assets/image/security2-logo42.png" alt="">
            </div>
            <div class="con-box">
              <p class="p1">超3000万美金保险额</p>
              <p class="p2"> EBC Financial Group（UK）Ltd 和EBC Financial Group（Cayman）Ltd 每年向英国劳合社购买200万英镑保额的董事与高管责任险（D&O），以覆盖企业管理和经营过程中所引起的损失和责任，同时购买200万英镑保额的网络保险（Cyber insurance），对于网络系统和硬件问题带来的损失提供赔付，并对事件响应、系统修复等提供后续服务和支持。
                  <span class="br"></span> EBC Financial Group（Australia）Pty Ltd 每年向英国劳合社购买200万澳元保额的专业责任险（PI），保护因提供服务的过程中可能的疏忽或失误所造成的用户损失和索赔。
                  <span class="br"></span>EBC旗下子公司每年向澳洲昆士兰保险集团（QBE Insurance） 购买超2500万美元的保险。
                  <span class="br"></span>所有保险，旨在降低包含金融服务相关在内等多种风险。投保方在服务期间由疏忽、失误、遗漏或不可抗力造成的损失和索赔，保险公司将按照对应保险条款进行赔付。</p>
              <router-link
                :to="'/LearningCenterInfo?id=LEARN-369-368'">{{ $t('security.security-page2.text10') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="security3">
      <div class="">
        <p class="public-title title-48_bold md-title-24_bold">{{ $t('WhyEBC.screen4.title') }}</p>
        <div class="honor-list">
          <div class="slide-box">
            <div class="" @click="jumPage('LEARN-647-43B')" :title="$t('WhyEBC.screen4.desc1')">
              <img src="../assets/image/Home/index-section7-award1.png" alt="">
              <p v-if="$t('WhyEBC.screen4.desc1')">{{ $t('WhyEBC.screen4.desc1') }}</p>
            </div>
            <div class="" @click="jumPage('LEARN-647-43B')" :title="$t('WhyEBC.screen4.desc2')">
              <img src="../assets/image/Home/index-section7-award2.png" alt="">
              <p v-if="$t('WhyEBC.screen4.desc2')">{{ $t('WhyEBC.screen4.desc2') }}</p>
            </div>
            <div class="" @click="jumPage('LEARN-2DC')" :title="$t('WhyEBC.screen4.desc4')">
              <img src="../assets/image/Home/index-section7-award3.png" alt="">
              <p v-if="$t('WhyEBC.screen4.desc4')">{{ $t('WhyEBC.screen4.desc4') }}</p>
            </div>
            <div class="" @click="jumPage('LEARN-2DC')" :title="$t('WhyEBC.screen4.desc5')">
              <img src="../assets/image/Home/index-section7-award4.png" alt="">
              <p v-if="$t('WhyEBC.screen4.desc5')">{{ $t('WhyEBC.screen4.desc5') }}</p>
            </div>
            <div class="" @click="jumPage('LEARN-2E5')" :title="$t('WhyEBC.screen4.desc3')">
              <img src="../assets/image/Home/index-section7-award5.png" alt="">
              <p v-if="$t('WhyEBC.screen4.desc3')">{{ $t('WhyEBC.screen4.desc3') }}</p>
            </div>
            <div class="" @click="jumPage('LEARN-30-363')" :title="$t('WhyEBC.screen4.desc6')">
              <img src="../assets/image/Home/index-section7-award6.png" alt="">
              <p v-if="$t('WhyEBC.screen4.desc6')">{{ $t('WhyEBC.screen4.desc6') }}</p>
            </div>
            <div class="" @click="jumPage('LEARN-559-34F')" :title="$t('WhyEBC.screen4.desc7')">
              <img src="../assets/image/Home/index-section7-award7.png" alt="">
              <p v-if="$t('WhyEBC.screen4.desc7')">{{ $t('WhyEBC.screen4.desc7') }}</p>
            </div>
            <div class="" @click="jumPage('LEARN-486-3D7')" :title="$t('WhyEBC.screen4.desc8')">
              <img src="../assets/image/Home/index-section7-award8.png" alt="">
              <p v-if="$t('WhyEBC.screen4.desc8')">{{ $t('WhyEBC.screen4.desc8') }}</p>
            </div>
            <div class="" @click="jumPage('LEARN-518-4C3')" :title="$t('WhyEBC.screen4.desc9')">
              <img src="../assets/image/Home/index-section7-award9.png" alt="">
              <p v-if="$t('WhyEBC.screen4.desc9')">{{ $t('WhyEBC.screen4.desc9') }}</p>
            </div>
          </div>
          <div class="seeMore md-content-16_medium">
              <span class="seeMoreWord">查看更多</span>
              <i class="iconfont icon-right"></i>
            </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
  import seamscroll from '../assets/js/seamless.min.js'
  import fadeAnimate from "../mixins/fadeAnimate.js";

import {
  mapState,
} from 'vuex'
export default {
  mixins: [fadeAnimate],
  head() {
    return {
      title: this.title1,
      meta: [ // set meta
        {
          name: 'keyWords',
          content: 'EBC,EBC平台,EBC官网,EBC金融官网,EBC开户,EBC金融'
        },
        {
          name: 'description',
          content: 'EBC金融官网是由EBC金融集团EBC Financial Group成立的,主要提供,EBC金融,EBC开户交易服务,只需一个EBC综合平台账户,即可交易多种差价合约（CFD）:衍生品、美股、数字货币、期货指数、贵金属和能源等.'
        }
      ]
    }
  },
  data() {
    return {
      infoData: "",
      newData: "",
      pagIndex: 0,
      num: 3,
      newsdisplay: "none"
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Lan,
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll, false)
  },
  created() {
    $('html,body').animate({
      scrollTop: 0
    }, 0);
  },
  mounted() {
    
    this.initPage();

  },
  methods: {
    initPage(){
      if (window.matchMedia("(min-width: 996px)").matches) {
        seamscroll.init({
          dom: document.getElementsByClassName("slide-box")[0],
          direction: 2,
          step: 0.6,
          hoverStep: 0.3,
          hoverStop: false,
        });
      } else {
        document
          .querySelector(".security3 .slide-box")
          .classList.add("hiddenBox");
        document
          .querySelector(".seeMore")
          .addEventListener("click", function (e) {
            document
              .querySelector(".security3 .slide-box")
              .classList.toggle("hiddenBox");
            let seeMore = document.querySelector(".seeMore");
            let seeMoreWord = document.querySelector(".seeMoreWord");
            seeMore.classList.toggle("active");
            if (seeMore.classList.contains("active")) {
              seeMoreWord.innerHTML = "收起";
            } else {
              seeMoreWord.innerHTML = "查看更多";
            }
          });
      }
    },
    jumPage(id) {
      this.$router.push({
        name: 'LearningCenterInfo',
        query: {
          id: id
        }
      })
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
}

</script>
<style scoped>
  .security1 {
  padding: 160rem 0 120rem;
}

.public-title {
  margin-bottom: 60rem;
  text-align: center;
}

.security1 .row {
  max-width: 1200rem;
  margin-inline: auto;
  display: flex;
  justify-content: space-between;
  gap: 24rem;
}
.security1 .row > div {
  border-radius: var(--Corner-Radius-RC08, 8px);
  border: 1px solid var(--Neutral-Stroke, rgba(0, 0, 0, 0.12));
  background: var(--Neutral-BG_A, #fff);
  padding: 32rem;
  flex: 0 0 588rem;
  text-align: center;
}
.security1 .row img {
  width: auto;
  height: 56rem;
  margin-bottom: 24rem;
  /* border-radius: 50%; */
}
.security1 .row .p2 {
  color: var(--Text-Primary, #000);
  font-size: 16rem;
  font-style: normal;
  font-weight: 400;
  line-height: 24rem; /* 150% */
  margin-bottom: 8rem;
}
.security1 .row br {
  display: none;
}
.security1 .row a {
  border-radius: var(--Corner-Radius-Full, 999px);
  border: 1px solid var(--Function-Active-Normal, #a52933);
  display: flex;
  height: 40rem;
  padding: 8rem 24rem;
  justify-content: center;
  align-items: center;
  gap: 4rem;
  margin-top: 24rem;
  color: var(--Function-Active-Normal, #a52933);
  text-align: center;
  font-family: Sinter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  width: fit-content;
  margin-inline: auto;
}
.security1 .row a:hover {
  color: var(--ebc-text-primary_white) !important;
  background-color: var(--ebc-basecolor-active-500);
}
@media (max-width: 996px) {
  .security1 {
    padding: 80rem 0 160rem;
  }
  .public-title  {
    margin-bottom: 80rem;
  }
  .security1 .row {
    max-width: calc(100vw - 64rem);
    gap: 48rem;
  }
  .security1 .row > div {
    padding: 64rem 32rem;
    flex: 0 0 685rem;
  }
  .security1 .row img {
    width: 128rem;
    height: 128rem;
    margin-bottom: 48rem;
  }
  .security1 .row .p2 {
    color: var(--Text-Primary, #000);
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    margin-bottom: 16rem;
  }
  .security1 .row a {
    margin-top: 48rem;
    display: flex;
    height: 40px;
    padding: 8px 24px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: var(--Corner-Radius-Full, 999px);
    border: 1px solid var(--Function-Active-Normal, #a52933);
    color: var(--Function-Active-Normal, #a52933);
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
  }
}

.security2 {
  padding: 120rem 0;
  background: var(--Neutral-BG_B, #f7f7f7);
}

.security2 .row {
  display: flex;
  flex-direction: column;
  gap: 24rem;
  max-width: 1200rem;
  margin-inline: auto;
}

.security2 .row .br {
  display: block;
  margin-bottom: 14rem;
}

.security2 .row > div {
  display: flex;
  align-items: center;
  border-radius: var(--Corner-Radius-RC08, 8px);
  background: var(--Neutral-BG_A, #fff);
  justify-content: space-between;
}

.security2 .row > div img {
  max-width: 304rem;
  height: auto;
  margin-inline: auto;
}
.security2 .row > div .con-box {
  padding: 32rem 24rem;
  flex: 0 0 816rem;
}
.security2 .row > div .con-box .p1 {
  color: var(--Text-Primary, #000);
  font-size: 20rem;
  font-style: normal;
  font-weight: 500;
  line-height: 28rem; /* 140% */
  margin-bottom: 16rem;
}

.security2 .row > div .con-box .p2 {
  color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
  font-size: 14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 24rem; /* 171.429% */
  margin-bottom: 24rem;
}
.security2 .row > div .con-box a:hover {
  color: var(--ebc-text-primary_white) !important;
  background-color: var(--ebc-basecolor-active-500);
}
.security2 .row > div .con-box a {
  border-radius: var(--Corner-Radius-Full, 999px);
  border: 1px solid var(--Function-Active-Normal, #a52933);
  display: flex;
  height: 40px;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: var(--Function-Active-Normal, #a52933);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  width: fit-content;
}
  .security2 .securityImg{
    text-align: center;
    flex: 1;
  }
.security2 .row > div:nth-child(3) img{
height: 120rem;
width: auto;
}
.security2 .row > div:nth-child(3) img:nth-child(1){
  margin-right: 44rem;
}
.security2 .row > div:nth-child(4) img{
  width: 224rem;
  height: auto;
}
.security2 .row > div:nth-child(4) img:nth-child(1){
  margin-bottom: 32rem;
}
@media (max-width: 996px) {
  .security2 {
    padding: 160rem 32rem;
  }
  .security2 .row .br {
  margin-bottom: 28rem;
}
  .security2 .row > div {
    width: 100%;
    flex-direction: column;
  }
  .security2 .row > div .securityImg{
    flex: 0 0 240rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 138rem;
  }
  .security2 .row > div:nth-child(3) .securityImg img{
    margin:0;
    width: 128rem;
    height: auto;
  }
  .security2 .row > div:nth-child(4) .securityImg{
    flex: 0 0 320rem;
    flex-direction: column;
    gap: 48rem;
  }
  .security2 .row > div:nth-child(4) .securityImg img{
    margin: 0;
    width: 300rem;
    height: auto;
  }
  .security2 .row > div .con-box {
    flex: 1;
    padding: 48rem 32rem;
  }
  .security2 .row > div img {
    max-width: 256px;
    margin-block: auto;
  }
  .security2 .row > div .con-box .p1 {
    font-size: 32rem;
    font-style: normal;
    font-weight: 500;
    line-height: 48rem;
    margin-bottom: 32rem;
  }
  .security2 .row > div .con-box .p2 {
    font-size: 28rem;
    line-height: 48rem;
    margin-bottom: 48rem;
  }
  .security2 .row > div .con-box a {
    display: flex;
    height: 40px;
    padding: 8px 24px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    border-radius: var(--Corner-Radius-Full, 999px);
    border: 1px solid var(--Function-Active-Normal, #a52933);
    color: var(--Function-Active-Normal, #a52933);
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    width: 100%;
  }
}

.security3{
  padding: 120rem 0;
  overflow: hidden;
}

.security3 .slide-box{
  display: flex;

}
.security3 .slide-box>div{
  margin-inline: 40rem;
 flex:0 0 300rem;
 text-align: center;
}
.security3 .slide-box>div img{
 width: auto;
  height: 310rem;
}

.seeMore{
  display: none;
}
@media (max-width: 996px) {
   .security3{
    padding: 160rem 0;
   }
  .security3 .slide-box{
 flex-direction: column;
 gap: 96rem;
  align-items: center;
}
.security3 .slide-box>div img{
 width: 452rem;
  height: auto;
}
.security3 .slide-box.hiddenBox>div:nth-child(n+6){
  display: none;
}
.seeMore{
  display: block;
  text-align: center;
  margin-top: 80rem;
  color:  #A52933;

}
.seeMore .iconfont{
  transform: rotate(90deg);
  display: inline-block;
}
.seeMore.active .iconfont{
  transform: rotate(-90deg);

}
}
</style>
